// Memorial entry for Shlomo Mansour
import shlomoMansourPortrait from '../../../images/shlomo-mansour.jpg';

export const shlomoMansourMemorial = {
  id: 33,
  name: 'Shlomo Mansour',
  images: {
    portrait: shlomoMansourPortrait
  },
  info: `
"In his childhood he survived the Farhud Holocaust, and now in his old age he did not survive the Holocaust that befell us on October 7." - His sister Hadassah

# Shlomo Mansour

![Shlomo Mansour](${shlomoMansourPortrait})
*Shlomo Mansour, 85, survivor of the Farhud, legendary carpenter of Kibbutz Kisufim*

## From Baghdad to the Negev

Shlomo Mansour was born Salman in Baghdad in 1938. His nickname was "Asa'ad" - "the happiest man" - because of his easy smiles. At age 3, he survived the Farhud, the 1941 pogrom against Baghdad's Jews. He carried those nightmares his whole life.

In 1951, at age 13, he immigrated to Israel. At 16, he became a founding member of Kibbutz Kisufim, where he lived for 70 years.

## The Legendary Carpenter

Shlomo was Kisufim's legendary carpenter - a man with "hands of gold" who could fix everything and make art from any object. Everyone knew him by his spectacular mustache and warm smile.

"If you'd cross paths with him, he would smile at you immediately," his daughter remembered. He rode his bike around the kibbutz saying hello to everyone.

He married Mazal and they raised five children over 60 years together.

## October 7, 2023

On that Shabbat morning - during Simchat Torah, just as the Farhud happened during Shavuot - Hamas attacked. About five terrorists shot down their safe room door.

They handcuffed 85-year-old Shlomo, beat him, and took him to Gaza in his pajamas without glasses or hearing aid. Mazal escaped to neighbors.

Shlomo was killed on October 7, 2023 - the same day. He was the oldest Israeli hostage.

## 509 Days

On February 11, 2025, the IDF confirmed he had been killed on October 7 itself. His body returned February 27, 2025. Thousands lined the roads. Many wore mustache-design sweatshirts in tribute.

His sister Hadassah: "In the Farhud he was with his family, and now he's alone."

He survived one pogrom at age 3 only to be killed in another at age 85.

*Salt of the earth, the beating heart of Kisufim. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/shlomo-mantzur-85-baghdad-native-was-kibbutzs-legendary-carpenter/)
`
};
